'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListContainer = exports.listBuilder = undefined;

var _reactRedux = require('react-redux');

var _List = require('../../Presentational components/List/List');

var _List2 = _interopRequireDefault(_List);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listBuilder = exports.listBuilder = function listBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_List2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    title: state.app.list.title,
    columns: state.app.list.columns,
    items: state.app.list.items
  };
};

var ListContainer = exports.ListContainer = listBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/ListContainer/ListContainer.js
 ** module id = 278
 ** module chunks = 0
 **/